import content from './content';
import { useState } from 'react';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import { Text, Title } from './PopUpErrorAddMember.styles';
import { type PopupProps, Popup } from '@CS/components/Popups';

export const PopUpErrorAddMember = ({ ...props }: PopupProps) => {
  const { title, text, button } = useTranslation(content);
  const [closed, setClosed] = useState(false);
  const onClick = () => setClosed(true);

  return (
    <Popup close={closed} {...props}>
      <Title>{title}</Title>
      <Text>{text}</Text>
      <Button onClick={onClick} text={button} />
    </Popup>
  );
};
